import styled, { css } from 'styled-components'

export const GlobalVariables = css<{ $colorMode?: 'light' | 'dark' }>`
  // COLORS
  // 🟦
  --brandblue-main: #202346;
  --brandblue-bright-1: #474a66;
  --brandblue-bright-2: #6f7187;
  --brandblue-bright-3: #9698a8;
  --brandblue-bright-4: #c8c8d1;
  --brandblue-bright-5: #f0f0f2;

  --blue-dark-2: #1b475e;
  --blue-dark-1: #296a8d;
  --blue-main: #378ebd;
  --blue-bright-1: #69aacd;
  --blue-bright-2: #9bc6de;
  --blue-bright-3: #cde2ee;

  // 🟨
  --yellow-main: #ffe462;

  // 🟪
  --petrol-dark-2: #16514f;
  --petrol-dark-1: #217977;
  --petrol-main: #2ca29f;
  --petrol-bright-1: #60b9b7;
  --petrol-bright-2: #95d0cf;
  --petrol-bright-3: #cae7e7;

  // 🟩
  --green-dark-2: #234930;
  --green-dark-1: #356d48;
  --green-main: #479260;
  --green-bright-1: #75ad87;
  --green-bright-2: #a3c8af;
  --green-bright-3: #d1e3d7;

  // 🟪
  --purple-dark-2: #512a4f;
  --purple-dark-1: #7a3f77;
  --purple-main: #a757a3;
  --purple-bright-1: #ba7fb7;
  --purple-bright-2: #d1aacf;
  --purple-bright-3: #e8d4e7;

  // 🟧
  --orange-dark-2: #703600;
  --orange-dark-1: #964800;
  --orange-main: #e16d00;
  --orange-bright-1: #e78d38;
  --orange-bright-2: #f1be8d;
  --orange-bright-3: #f8dec6;

  // 🟥
  --red-dark-2: #691a1f;
  --red-dark-1: #9e272f;
  --red-main: #d3343f;
  --red-bright-1: #de666f;
  --red-bright-2: #e9999f;
  --red-bright-3: #f4cccf;

  // 🟫
  --beige-dark-2: #575247;
  --beige-dark-1: #7b7768;
  --beige-main: #a09c8a;
  --beige-bright-1: #dcd8c9;
  --beige-bright-2: #efece0;
  --beige-bright-3: #f8f7f4;

  // ⬜️
  --gray-1: #121212;
  --gray-2: #555;
  --gray-3: #7d7d7d;
  --gray-4: #d4d4d4;
  --gray-5: #e9e9e9;
  --gray-6: #f4f4f4;

  --tenant-bz: #800000;
  --tenant-bol: #800000;
  --tenant-lt: #800000;
  --tenant-tt: #800000;
  --tenant-zrz: #2c3890;
  --tenant-tdg: #2c3890;
  --tenant-zul: #2c3890;
  --tenant-l: #2c3890;
  --tenant-baz: #d9010e;
  --tenant-24h: #d9010e;
  --tenant-bnd: #0085ab;
  --tenant-ta: #0085ab;

  
  --site-background: #fff;

  ${({ $colorMode }) =>
    $colorMode === 'dark'
      ? css`
          // 🌚 all Dark Mode variables
          --tenant-bz: #9c3838;
          --tenant-bol: #9c3838;
          --tenant-lt: #9c3838;
          --tenant-tt: #9c3838;
          --tenant-zrz: #5a64a8;
          --tenant-tdg: #5a64a8;
          --tenant-zul: #5a64a8;
          --tenant-l: #5a64a8;

          
          --site-background: var(--gray-1);
        `
      : ''}

  // FONTS
  --font-plex: "IBM Plex Sans","Helvetica",Arial,Verdana,Helvetica,sans-serif;
  --font-noto: 'Noto Serif', 'Times New Roman', Helvetica, serif;
  color: var(--text-color);

  // TOGGLE

  .toggleWrapper,
  .bigToggleWrapper {
    font-family: var(--chart-font-stack);
    width: 100%;
    text-align: center;
    font-size: 0.8em;
    padding-top: 0.25em;
    padding-bottom: 1.5em;
    background: var(--site-background);

    // border-top: 1px solid #d6d7dd;
    display: inline-block;
    .toggleTitle {
      display: inline-block;
      width: 100%;
      margin-bottom: 1em;
    }
    .center {
      display: inline-block;
      margin-left: auto;
      margin-right: auto;
      width: 100%;

      display: flex;
      align-items: center;
      justify-content: center;
    }
    .label {
      float: left;
      text-align: right;
      padding-right: 1em;
      min-width: 90px;
      width: calc(50% - 25px);
      line-height: 1.3em;
      color: var(--text-color);
      &.off {
        color: #999baa;
      }
      &.right {
        padding-left: 1em;
        text-align: left;
      }
    }

    .toggleContainer {
      // float: left;
      display: flex;
    }
  }
  .optionsWrapper {
    clear: both;
    width: 100%;
    display: inline-block;
    // display: flex;
    // flex-flow: row wrap;
    // justify-content: flex-start;

    // margin-bottom: 2em;
    margin-top: 1em;
    border-top: 1px solid #d6d7dd;
    @media only screen and (max-width: 599px) {
      display: inline-block;
      margin-bottom: 0em;
      margin-top: 1em;
    }
  }
  .bigToggleWrapper {
    flex-grow: 1;
    flex-basis: 50%;
    width: 50%;

    line-height: 0;
    float: left;
    border-top: 0;
    padding: 0;
    padding-left: 1em;
    padding-right: 1em;
    margin-top: 1em;
    @media only screen and (min-width: 600px) {
      &:nth-child(2n + 1) {
        border-right: 1px solid #d6d7dd;
      }
    }
    @media only screen and (max-width: 599px) {
      width: 100%;
      padding-left: 0;
      padding-right: 0;
      padding-bottom: 1em;
      border-right: 0;
      border-bottom: 1px solid #d6d7dd;
    }
    .toggleContainer {
      min-width: 50px;
    }
    .toggleTitle {
      margin: 0;
    }
    .label {
      width: auto;
      padding-top: 0.2em;
      font-weight: 700;
      min-width: initial;
      min-width: calc(50% - 25px);
      max-width: calc(50% - 25px);
      font-size: 0.9em;
      &.off {
        font-weight: 400;
      }
      @media only screen and (max-width: 599px) {
        min-width: calc(50% - 25px);
        font-size: 1em;
      }
    }
    .react-toggle:hover:not(.react-toggle--disabled) .react-toggle-track {
      background-color: #000;
      @media only screen and (max-width: 599px) {
        background-color: #d6d7dd;
      }
    }
    .react-toggle:active:not(.react-toggle--disabled) .react-toggle-track {
      background-color: #000;
      @media only screen and (max-width: 599px) {
        background-color: #d6d7dd;
      }
    }

    // .react-toggle--checked {
    //   .react-toggle-track {
    //     background-color: #d6d7dd;
    //   }
    // }
  }
  .bigToggleWrapper:last-of-type {
    // border-right: 0;
    // padding-right: 0;
    border-bottom: 0;
  }
  .bigToggleWrapper:first-of-type {
    margin-left: 0;
    // padding-left: 0;
  }
  // CSS FÜR DEN SCHALTER
  .react-toggle {
    touch-action: pan-x;
    display: inline-block;
    position: relative;
    cursor: pointer;
    background-color: transparent;
    border: 0;
    padding: 0;

    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-tap-highlight-color: transparent;
  }

  .react-toggle-screenreader-only {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }

  .react-toggle--disabled {
    cursor: not-allowed;
    opacity: 0.5;
    -webkit-transition: opacity 0.25s;
    transition: opacity 0.25s;
  }

  .react-toggle-track {
    width: 50px;
    height: 24px;
    padding: 0;
    border-radius: 30px;
    background-color: #c8c8d1;
    -webkit-transition: all 0.2s ease;
    -moz-transition: all 0.2s ease;
    transition: all 0.2s ease;
  }

  .react-toggle:hover:not(.react-toggle--disabled) .react-toggle-track {
    background-color: #000000;
  }

  .react-toggle--checked .react-toggle-track {
    background-color: #202346;
  }

  .react-toggle--checked:hover:not(.react-toggle--disabled)
    .react-toggle-track {
    background-color: #202346;
  }

  .react-toggle-track-check {
    position: absolute;
    width: 14px;
    height: 10px;
    top: 0px;
    bottom: 0px;
    margin-top: auto;
    margin-bottom: auto;
    line-height: 0;
    left: 8px;
    opacity: 0;
    -webkit-transition: opacity 0.25s ease;
    -moz-transition: opacity 0.25s ease;
    transition: opacity 0.25s ease;
  }

  .react-toggle--checked .react-toggle-track-check {
    opacity: 1;
    -webkit-transition: opacity 0.25s ease;
    -moz-transition: opacity 0.25s ease;
    transition: opacity 0.25s ease;
  }

  .react-toggle-track-x {
    position: absolute;
    width: 10px;
    height: 10px;
    top: 0px;
    bottom: 0px;
    margin-top: auto;
    margin-bottom: auto;
    line-height: 0;
    right: 10px;
    opacity: 1;
    -webkit-transition: opacity 0.25s ease;
    -moz-transition: opacity 0.25s ease;
    transition: opacity 0.25s ease;
  }

  .react-toggle--checked .react-toggle-track-x {
    opacity: 0;
  }

  .react-toggle-thumb {
    transition: all 0.5s cubic-bezier(0.23, 1, 0.32, 1) 0ms;
    position: absolute;
    top: 1px;
    left: 1px;
    width: 22px;
    height: 22px;
    border: 1px solid #4d4d4d;
    border-radius: 50%;
    background-color: #fafafa;

    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;

    -webkit-transition: all 0.25s ease;
    -moz-transition: all 0.25s ease;
    transition: all 0.25s ease;
  }

  .react-toggle--checked .react-toggle-thumb {
    left: 27px;
    border-color: #202346;
  }

  .react-toggle--focus .react-toggle-thumb {
    -webkit-box-shadow: 0px 0px 3px 2px #0099e0;
    -moz-box-shadow: 0px 0px 3px 2px #0099e0;
    box-shadow: 0px 0px 2px 3px #0099e0;
  }

  .react-toggle:active:not(.react-toggle--disabled) .react-toggle-thumb {
    -webkit-box-shadow: 0px 0px 5px 5px #0099e0;
    -moz-box-shadow: 0px 0px 5px 5px #0099e0;
    box-shadow: 0px 0px 5px 5px #0099e0;
  }
  .personalGrid {
    width: 100%;
    display: inline-block;
    @media only screen and (max-width: 599px) {
      width: 106%;
    }
    .col {
      // border: 1px solid #f00;
      width: 15%;
      margin-right: 1.666666%;
      // padding-right: 14px;
      float: left;
      @media only screen and (max-width: 599px) {
        width: 47%;
        margin-right: 3%;
        padding-right: 0px;
      }
      &.flipVert {
        margin-top: 0 !important;
      }

      &.key {
        display: inline-block;
        opacity: 1;
        width: calc(100%);
        @media only screen and (max-width: 599px) {
          width: calc(100% - 8px);
        }
      }
      &.fixedrest {
        clear: both;
        display: inline-block;
        width: 100%;
      }
      .fixed {
        width: calc(100%) !important;
        @media only screen and (max-width: 599px) {
          width: calc(100% - 8px) !important;
        }
      }
    }
  }
`
